import React, { useEffect, useState } from 'react'
import DataPartners from './DataPartners'
import { PartnerInterface, DefaultPartnerInterface, ShowPartnersContext } from './types'
import AddPartner from './AddPartners'
import SuccessMsg from '../../Messages/SuccessMsg'
import EditPartner from './EditPartner'
import DeletePartner from './DeletePartner'
import { FaChevronCircleLeft, FaPlus } from 'react-icons/fa'
import { Outlet, useNavigate, useParams  } from 'react-router'
import { useDispatch } from 'react-redux'
import { ShowPartnerApi } from '../../redux/partners/partnerApiCalls'

const ShowPartners:React.FC = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [showAddModal, setShowAddModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [selectedPartner, setSelectedPartner] = useState<PartnerInterface>(DefaultPartnerInterface)
  const [selectedDoctor, setSelectedDoctor] = useState<any[]>([]);
  const [hideDataPartner, setHideDataPartner] = useState(false)
  const { AssId } = useParams()
  const navigate = useNavigate()

  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchAss = async () => {
      await dispatch(ShowPartnerApi());
    };
    fetchAss();
  }, [dispatch]);


  return (
    <ShowPartnersContext.Provider value={{
      showSuccessMsg,
      setShowSuccessMsg,
      showEditModal, 
      setShowEditModal,
      showDeleteModal, 
      setShowDeleteModal,
      selectedPartner,
      setSelectedPartner,
      selectedDoctor, setSelectedDoctor,
      hideDataPartner, setHideDataPartner,
      showAddModal, setShowAddModal
    }}>
      {showSuccessMsg && <SuccessMsg modal={showSuccessMsg} toggle={() => setShowSuccessMsg(!showSuccessMsg)}/> }

      {showAddModal && <AddPartner modal={showAddModal} toggle={() => setShowAddModal(!showAddModal)} /> }
      
      {!AssId ? <>
        <div className="flex justify-start gap-2 mt-2">
          <FaChevronCircleLeft style={{ fontSize: "30px" }} className="text-main" onClick={() => navigate("/")}/>
          <button className="p-2 rounded btn-main" onClick={() => setShowAddModal(!showAddModal)}>
            <FaPlus />
          </button>
        </div>
        <DataPartners />
      </>
      :
      <></>
        // <FaChevronCircleLeft className='text-main mt-2' style={{ fontSize: "30px" }} onClick={() => { 
        //   navigate(`/partners`)
        // }} /> 
      }
      
      {showEditModal && selectedPartner?._id && <EditPartner PartnerData={selectedPartner} modal={showEditModal}  toggle={() => setShowEditModal(!showEditModal)} />}
      {showDeleteModal && selectedPartner?._id && <DeletePartner PartnerData={selectedPartner} modal={showDeleteModal}  toggle={() => setShowDeleteModal(!showDeleteModal)} />}
      <Outlet />
    </ShowPartnersContext.Provider>
  )
}

export default ShowPartners
